/**
 * Sort Service
 * @class Sort
 * @property {boolean} sorted 정렬 함
 * @property {boolean} unsorted 정렬하지 않음
 */
class Sort {
  constructor(props) {
    this.sorted = props.sorted
    this.unsorted = props.unsorted
    this.empty = props.empty
  }
}

/**
 * Pageable Service
 * @class Pageable
 * @property {object} sort 정렬 정보
 * @property {number} pageNumber 현재 페이지
 * @property {number} pageSize 페이지 사이즈
 * @property {object} paged 페이징 처리 여부
 * @property {number} unpaged 페이징 미처리 여부
 */
class Pageable {
  constructor(props) {
    this.sort = new Sort(props.sort)
    this.pageNumber = props.pageNumber
    this.pageSize = props.pageSize
    this.paged = props.paged
    this.unpaged = props.unpaged
    this.offset = props.offset
  }
}

/**
 * ModelInfo Service
 * @class ModelInfo
 * @property {number} totalPages 전체 페이지
 * @property {number} totalElements 전체 콘텐츠 갯수
 * @property {object} sort 정렬 정보
 * @property {boolean} first 첫 페이지
 * @property {boolean} last 마지막 페이지
 * @property {number} number 현재 페이지
 * @property {number} numberOfElements 현재 페이지 콘텐츠 갯수
 * @property {object} pageable 페이지 정보
 * @property {number} size 페이지 사이즈
 * @property {array} content 콘텐츠 정보
 */
export class ModelInfo {
  constructor(props) {
    this.totalPages = props.totalPages
    this.totalElements = props.totalElements
    this.sort = new Sort(props.sort)
    this.first = props.false
    this.last = props.last
    this.number = props.number
    this.numberOfElements = props.numberOfElements
    this.pageable = new Pageable(props.pageable)
    this.size = props.size
    this.content = props.content
    this.empty = props.empty
  }
}
